import React from 'react';

export default () => (
  <svg fill="#1d303c" version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24">
    <g id="Bounding_Boxes">
      <g id="ui_x5F_spec_x5F_header_copy_3" display="none" />
      <path fill="none" d="M0,0h24v24H0V0z" />
    </g>
    <g id="Outline">
      <g id="ui_x5F_spec_x5F_header" display="none" />
      <path
        d="M14,5h8v2h-8V5z M14,10.5h8v2h-8V10.5z M14,16h8v2h-8V16z M2,11.5C2,15.08,4.92,18,8.5,18H9v2l3-3l-3-3v2H8.5
            C6.02,16,4,13.98,4,11.5S6.02,7,8.5,7H12V5H8.5C4.92,5,2,7.92,2,11.5z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/LowPriority.js